type Props = {
    text: string
    clazz?: string,
    cssStyles?: string,
  };

function Subtitle({text, clazz = 'text-2xl md:text-3xl', cssStyles = ''}: Props) {
    return (
        <h2 className={`font-sans font-semibold ${clazz} text-slate-700 ${cssStyles}`}>
            {text}
        </h2>
    );
}

export default Subtitle;